import React, { memo } from 'react';
import { useFeatureStore } from '../../zustand/features';

export interface FeatureGateProps {
  feature?: string | string[];
  allRequired?: boolean;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export const FeatureGate: React.FC<FeatureGateProps> = memo(
  ({ feature, allRequired = true, fallback = null, children }) => {
    const isLoaded = useFeatureStore((state) => state?.isLoaded ?? false);
    const hasAccess = useFeatureStore((state) => {
      if (!feature) return true;
      const features = state?.features ?? [];
      if (Array.isArray(feature)) {
        if (feature.length === 0) return true;
        return allRequired
          ? feature.every((f) => features.includes(f))
          : feature.some((f) => features.includes(f));
      }
      return features.includes(feature);
    });

    if (!isLoaded) {
      return null;
    }

    if (!hasAccess) {
      return fallback ? <>{fallback}</> : null;
    }

    return <>{children}</>;
  }
);

FeatureGate.displayName = 'FeatureGate';

export default FeatureGate;
